import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import { useAuth } from './AuthContext';

export function ProtectedRoute() {
  const { status } = useAuth();
  const { t } = useI18n();
  const location = useLocation();
  if (status === 'loading') return <main className="loading-screen">{t('session.loading')}</main>;
  if (status !== 'authenticated') return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}
